import type { SearchSuggestionQuery } from '@/api/v4/search.api';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export type SearchResultsFilter =
  | 'all'
  | 'project'
  | 'organization'
  | 'team'
  | 'tag'
  | 'file';

export const searchResultsFilters: SearchResultsFilter[] = [
  'all',
  'organization',
  'project',
  'team',
  'tag',
  'file',
];

export const searchResultsFilterState = atom<SearchResultsFilter>('all');

export const defaultSearchQueryState: SearchSuggestionQuery = {
  search: '',
  page: 1,
  pageSize: 12,
  entities: ['all'],
};

export const searchQueryState = atomWithReset<SearchSuggestionQuery>(
  defaultSearchQueryState,
);
